"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AnalyticsReportsEntity_1 = __importDefault(require("./Entity/AnalyticsReportsEntity"));
var AnalyticsReportsApi = /** @class */ (function () {
    function AnalyticsReportsApi(session) {
        this.analyticsReportsEntity = new AnalyticsReportsEntity_1.default(session);
    }
    AnalyticsReportsApi.prototype.getReport = function (reportId) {
        return this.analyticsReportsEntity.getReport(reportId);
    };
    AnalyticsReportsApi.prototype.getUserReports = function (queryString) {
        return this.analyticsReportsEntity.getUserReports(queryString);
    };
    AnalyticsReportsApi.prototype.getSystemReports = function (queryString) {
        return this.analyticsReportsEntity.getSystemReports(queryString);
    };
    AnalyticsReportsApi.prototype.createReportScheduledJob = function (queryParams) {
        return this.analyticsReportsEntity.createReportScheduledJob(queryParams);
    };
    AnalyticsReportsApi.prototype.updateReportScheduledJob = function (jobId, queryParams) {
        return this.analyticsReportsEntity.updateReportScheduledJob(jobId, queryParams);
    };
    AnalyticsReportsApi.prototype.getReportScheduledJob = function (jobId) {
        return this.analyticsReportsEntity.getReportScheduledJob(jobId);
    };
    AnalyticsReportsApi.prototype.deleteReportScheduledJob = function (jobId) {
        return this.analyticsReportsEntity.deleteReportScheduledJob(jobId);
    };
    AnalyticsReportsApi.prototype.isWebhookUsedInScheduledJobs = function (webhookUuid) {
        return this.analyticsReportsEntity.isWebhookUsedInScheduledJobs(webhookUuid);
    };
    AnalyticsReportsApi.prototype.getApiLink = function () {
        return this.analyticsReportsEntity.getApiLink();
    };
    AnalyticsReportsApi.prototype.getActiveReportExecutions = function () {
        return this.analyticsReportsEntity.getActiveReportExecutions();
    };
    AnalyticsReportsApi.prototype.removeReportExecution = function (executionId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.analyticsReportsEntity.removeReportExecutions(executionId)];
            });
        });
    };
    AnalyticsReportsApi.prototype.subscribeReportExecutions = function (handler) {
        this.analyticsReportsEntity.subscribeReportExecutions(handler);
    };
    AnalyticsReportsApi.prototype.unsubscribeReportExecutions = function () {
        this.analyticsReportsEntity.unsubscribeReportExecutions();
    };
    AnalyticsReportsApi.prototype.getReportRowsCount = function (queryJson, timezone) {
        return this.analyticsReportsEntity.getReportRowsCount(queryJson, timezone);
    };
    AnalyticsReportsApi.prototype.optOutReport = function (reportId) {
        return this.analyticsReportsEntity.optOutReport(reportId);
    };
    /**
     * @deprecated
     */
    AnalyticsReportsApi.prototype.createReport = function (report) {
        return this.analyticsReportsEntity.createReport(report);
    };
    /**
     * @deprecated
     */
    AnalyticsReportsApi.prototype.updateReport = function (reportId, report) {
        return this.analyticsReportsEntity.updateReport(reportId, report);
    };
    /**
     * @deprecated
     */
    AnalyticsReportsApi.prototype.deleteReport = function (reportId) {
        return this.analyticsReportsEntity.deleteReport(reportId);
    };
    /**
     * @deprecated
     */
    AnalyticsReportsApi.prototype.exportReport = function (reportId, queryParams) {
        return this.analyticsReportsEntity.exportReport(reportId, queryParams);
    };
    /**
     * @deprecated
     */
    AnalyticsReportsApi.prototype.downloadReport = function (reportId, queryParams) {
        return this.analyticsReportsEntity.downloadReport(reportId, queryParams);
    };
    /**
     * @deprecated
     */
    AnalyticsReportsApi.prototype.retryReportExecution = function (executionId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.analyticsReportsEntity.retryReportExecutions(executionId)];
            });
        });
    };
    return AnalyticsReportsApi;
}());
exports.default = AnalyticsReportsApi;
//# sourceMappingURL=AnalyticsReportsApi.js.map